const initialState = {
  app: {
    hasInternet: true,
  },
};

export default initialState;
